import RoleLogin from "@/pages/RoleLogin";

export default function StaffLogin() {
  return (
    <RoleLogin role="RECEPTIONIST" portalLabel="Staff Portal" dashboardPath="/staff/dashboard" testPrefix="staff" />
  );
}
